import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dnevna skica st1",
  "description": "",
  "published": "2006-06-07T00:00:00.000Z",
  "redirect_from": ["/blog/dnevna-skica-st1/swizec/405"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`No, dokler ni ustvarjen stolpec za tele stvarce je tu prva.`}</p>
    <p>{`Lik na skici je v bistvu gost v drugi epizodi stripa Cthulhu.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sketches/kscan_0131.png",
        "alt": null
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      